import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Onboarding
export const onboardingApi = {
  complete: (data) => api.post('/onboarding/complete', data),
};

// Treasury
export const treasuryApi = {
  get: () => api.get('/treasury'),
  update: (data) => api.put('/treasury', data),
  toggleEmergencyStop: () => api.post('/treasury/emergency-stop'),
};

// Agents
export const agentsApi = {
  getAll: () => api.get('/agents'),
  getOne: (id) => api.get(`/agents/${id}`),
  create: (data) => api.post('/agents', data),
  kill: (id, reason) => api.post(`/agents/${id}/kill`, null, { params: { reason } }),
  clone: (id, mutation) => api.post(`/agents/${id}/clone`, null, { params: { mutation } }),
  reallocate: (id, newBudget) => api.post(`/agents/${id}/reallocate`, null, { params: { new_budget: newBudget } }),
};

// Experiments
export const experimentsApi = {
  getAll: () => api.get('/experiments'),
  create: (data) => api.post('/experiments', data),
};

// Approvals
export const approvalsApi = {
  getAll: () => api.get('/approvals'),
  create: (data) => api.post('/approvals', data),
  review: (id, approved, notes) => api.post(`/approvals/${id}/review`, null, { params: { approved, notes } }),
};

// Audit Logs
export const auditApi = {
  getLogs: (limit = 100) => api.get('/audit-logs', { params: { limit } }),
};

// Dashboard
export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
};

// Simulation
export const simulationApi = {
  tick: () => api.post('/simulation/tick'),
  seedDemo: () => api.post('/seed-demo'),
};

// Health
export const healthApi = {
  check: () => api.get('/health'),
};

export default api;
